import React from 'react';
import {
  ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography, FormControl,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { bindActionCreators } from 'redux';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getFaqCategory,
  getAllFaqQuestionBYCategoryId,
} from '../../Actions/actions';
import SearchText from '../common/searchtext';
import 'react-responsive-ui/style.css';
import loader from '../../images/Spin-1s-107px.gif';

class DetailFaq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
      faqCategories: [],
      faqQuestionsAnswers: [],
      searchKeyword: '',
      catId: 0,
      isLoader: false,
    };
  }

  /**
     * Handle the event when Click on Expansions.
     * @param { event} e
     * @param { expanded } expansion Id
     */

    handleChange = panel => (event, expanded) => {
      this.setState({
        expanded: expanded ? panel : false,
      });
    };

    /**
     * Life Cycle Trigger when componenet mount and load faq categories
     */

    componentDidMount() {
      const { searchKeyword } = this.state;
      const data = {
        searchKeyword,
      };
      this.props.getFaqCategory(data);
      this.spinner();
    }

    /**
     * Get the Faq question and answer by categories
     */
    getFaqQuestionAndAnswer() {
      this.props.getAllFaqQuestionBYCategoryId({
        searchKeyword: '',
        catgoryId: this.state.catId,
      });
      this.spinner();
    }

    /**
     * Set the Loader
     */
    spinner() {
      setTimeout(() => {
        this.setState({ isLoader: false });
      }, 1000 / 6);
    }

    componentDidUpdate() {
      const { faqCategory, faqQuestions } = this.props.data;
      const { faqCategories, faqQuestionsAnswers } = this.state;
      if (faqCategory !== undefined) {
        if (faqCategories !== faqCategory) {
          this.setState({
            faqCategories: faqCategory,
          });
        }
      }
      if (faqQuestions !== undefined) {
        if (faqQuestionsAnswers !== faqQuestions) {
          this.setState({
            faqQuestionsAnswers: faqQuestions,
          });
        }
      }
    }

    render() {
      const {
        expanded, faqCategories, faqQuestionsAnswers, isLoader,
      } = this.state;
      let loader1;
      if (isLoader) {
        loader1 = (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        );
      }
      let expansion;
      if (faqCategories.length !== undefined) {
        expansion = faqCategories.map((doc, idx) => (
          <ExpansionPanel key={`s${idx}`} expanded={expanded === idx} onChange={this.handleChange(idx)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={() => this.setState({ catId: doc.id, isLoader: true }, this.getFaqQuestionAndAnswer)}>
              <Typography>{doc.categoryName}</Typography>

            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div className="faqQuestionsAnswers">
                {(faqQuestionsAnswers.length !== undefined) && faqQuestionsAnswers.map((doc1, idx1) => (
                  <ExpansionPanel key={`s${idx1}`}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>
                        {' '}
                        <strong> Question : </strong>
                        {doc1.question}
                      </Typography>

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <Typography>
                                            Answer :
                        {' '}
                        {doc1.answer}
                      </Typography>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ))}
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ));
      } else {
        expansion = <p>No records Found</p>;
      }

      return (
        <span>
          {loader1}
          <div className="section-content support">
            <div className="row">
              <div className="col s12 m12">
                <div className="col s12 search-faq-category">
                  <div style={{ marginTop: '25px' }} />
                  <FormControl>
                    <SearchText
                      id="custom-css-input"
                      value={this.state.searchKeyword}
                      onChange={event => this.setState({ searchKeyword: event.target.value, isLoader: true, expanded: null }, this.componentDidMount)}
                      placeholder="Search"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col s12">
                <div className="row ">
                  <div className="col s12 m12">
                    <div>
                      {expansion}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      );
    }
}


DetailFaq.contextTypes = {
  router: PropTypes.object.isRequired,
};
/**
 * Get the data from reducer
 * @param {*} state
 */
const mapStateToProps = state => ({
  data: state.data,
});

/**
 * Set the data in reducers
 * @param {*} dispatch
 */
const mapDispatchToProps = dispatch =>
  bindActionCreators({
    getFaqCategory,
    getAllFaqQuestionBYCategoryId,
  }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(DetailFaq));
